import { Plan } from '../plan';

export class FaimPremium extends Plan {
    public static readonly PLAN_TYPE = 'faim_premium';
}
